import React, { useState, useEffect } from 'react';

/* ══════════════════ Hero · 巨字水印版（方案五 · 用户选定）══════════════════
   背景：巨型描边 AIR 水印；中央：相框化静态头像 + 打字机 + tagline。
   不放职业事实条（避免求职页定式）；动态显影头像仍属 Contact 答题专属。 */

const fullText = 'Hello, my name is ';
const personalIntro = 'WEB3 BUILDER / RESEARCHER / FULL-TIME BELIEVER';

const HeroSection = () => {
  const [avatarVisible, setAvatarVisible] = useState(false);
  const [showText, setShowText] = useState(false);
  const [displayedText, setDisplayedText] = useState('');
  const [isTypingComplete, setIsTypingComplete] = useState(false);
  const [showTagline, setShowTagline] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAvatarVisible(true);
    }, 300);

    const textTimer = setTimeout(() => {
      setShowText(true);
    }, 1300);

    return () => {
      clearTimeout(timer);
      clearTimeout(textTimer);
    };
  }, []);

  useEffect(() => {
    if (showText) {
      let currentIndex = 0;
      const typeText = () => {
        if (currentIndex <= fullText.length) {
          setDisplayedText(fullText.slice(0, currentIndex));
          currentIndex++;
          setTimeout(typeText, 80);
        } else {
          setIsTypingComplete(true);
        }
      };
      typeText();
    }
  }, [showText]);

  useEffect(() => {
    if (isTypingComplete) {
      const taglineTimer = setTimeout(() => {
        setShowTagline(true);
      }, 100);
      return () => clearTimeout(taglineTimer);
    }
  }, [isTypingComplete]);

  return (
    <div className="hero-wm min-h-screen relative overflow-hidden flex flex-col items-center justify-center px-8">
      <style>{`
        .hero-wm { background: transparent; }
        .hw-ghost {
          position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;
          font-family: 'Bungee', sans-serif; font-size: clamp(10rem, 30vw, 26rem); line-height: 1;
          color: transparent; -webkit-text-stroke: 2px rgba(45,52,54,.09);
          pointer-events: none; user-select: none;
        }
        .hw-corner { position: absolute; width: 22px; height: 22px; pointer-events: none;
          border-color: rgba(45,52,54,.3); border-style: solid; border-width: 0; }
        .hw-tl { top: 20px; left: 22px; border-top-width: 2px; border-left-width: 2px; }
        .hw-tr { top: 20px; right: 22px; border-top-width: 2px; border-right-width: 2px; }
        .hw-bl { bottom: 20px; left: 22px; border-bottom-width: 2px; border-left-width: 2px; }
        .hw-br { bottom: 20px; right: 22px; border-bottom-width: 2px; border-right-width: 2px; }
        .hw-center { position: relative; display: flex; flex-direction: column; align-items: center; text-align: center; }
        .hw-avwrap {
          padding: 7px; border: 2px solid rgba(45,52,54,.35); border-radius: 6px;
          outline: 1px dashed rgba(45,52,54,.25); outline-offset: 4px; margin-bottom: 30px;
          box-shadow: 0 14px 34px rgba(60,42,10,.14);
          transition: opacity 1s ease;
        }
        .hw-avatar { width: 172px; height: 172px; border-radius: 4px; object-fit: cover; display: block; }
        .hw-scroll {
          position: absolute; bottom: 24px; left: 50%; transform: translateX(-50%);
          display: flex; flex-direction: column; align-items: center; gap: 7px;
          font-family: 'Goldman', sans-serif; font-size: .64rem; letter-spacing: .4em; color: #9ca3af;
          text-transform: uppercase;
        }
        .hw-scroll i {
          width: 1px; height: 30px; display: block;
          background: linear-gradient(to bottom, rgba(45,52,54,.5), transparent);
          transform-origin: top; animation: hwPulse 1.8s ease-in-out infinite;
        }
        @keyframes hwPulse {
          0% { transform: scaleY(0); opacity: 1; }
          55% { transform: scaleY(1); opacity: 1; }
          100% { transform: scaleY(1); opacity: 0; }
        }
        @media (max-width: 767px) {
          .hw-avatar { width: 132px; height: 132px; }
        }
        .hw-tagline {
          font-size: 1rem; color: #4b5563; letter-spacing: .1em;
          transition: opacity 1s ease, transform 1s ease;
          opacity: 0; transform: translateY(10px);
        }
        .hw-tagline.show { opacity: 1; transform: none; }
      `}</style>

      <div className="hw-ghost" aria-hidden="true">AIR</div>
      <span className="hw-corner hw-tl" aria-hidden="true"></span>
      <span className="hw-corner hw-tr" aria-hidden="true"></span>
      <span className="hw-corner hw-bl" aria-hidden="true"></span>
      <span className="hw-corner hw-br" aria-hidden="true"></span>

      <div className="hw-center">
        <div className={`hw-avwrap ${avatarVisible ? 'opacity-100' : 'opacity-0'}`}>
          <img
            src="/images/avatar.png"
            alt="Air's Avatar"
            className="hw-avatar"
          />
        </div>

        <div className="text-center mb-10">
          <h1 className="text-4xl md:text-6xl font-black text-gray-800 mb-6 min-h-[3rem] md:min-h-[3.75rem]">
            <span className="bungee-regular">
              {displayedText}
            </span>
            {displayedText === fullText && (
              <span className="name-highlight">
                <span className="protest-revolution-regular font-black animate-gradient">
                  Air
                </span>
              </span>
            )}
            {showText && displayedText.length < fullText.length && (
              <span className="animate-pulse">|</span>
            )}
          </h1>

          <p className={`bitcount-grid-single hw-tagline whitespace-pre-line ${showTagline ? 'show' : 'invisible'}`}>
            {personalIntro}
          </p>
        </div>
      </div>

      <div className="hw-scroll" aria-hidden="true">
        <span>Scroll</span>
        <i></i>
      </div>
    </div>
  );
};

export default HeroSection;
